import React from 'react'

const Jva_bs = () => {
    return (
        <div className='container'>
            

  

<h1 class="h1">Bubble Sort in Java</h1>

<p>We can create a java program to sort array elements using bubble sort. Bubble sort algorithm is known as the
  simplest sorting algorithm.</p>
<p>In bubble sort algorithm, array is traversed from first element to last element. Here, current element is compared
  with the next element. If current element is greater than the next element, it is swapped.</p>

<div class="containers">
  <div class="dp-highlighter">
    <div class="bar">
      
    <ul start="1" class="dp-j">
      <li class="alt"><span><span class="keywords">public</span><span>&nbsp;</span><span
            class="keywords">class</span><span>&nbsp;BubbleSortExample&nbsp;&#123;&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span class="keywords">static</span><span>&nbsp;</span><span
            class="keywords">void</span><span>&nbsp;bubbleSort(</span><span
            class="keywords">int</span><span>[]&nbsp;arr)&nbsp;&#123;&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="keywords">int</span><span>&nbsp;n&nbsp;=&nbsp;arr.length;&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="keywords">int</span><span>&nbsp;temp&nbsp;=&nbsp;</span><span
            class="plain">0</span><span>;&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="keywords">for</span><span>(</span><span class="keywords">int</span><span>&nbsp;i=</span><span
            class="plain">0</span><span>;&nbsp;i&nbsp;&lt;&nbsp;n;&nbsp;i++)&#123;&nbsp;&nbsp;</span></span></li>
      <li class="">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="keywords">for</span><span>(</span><span class="keywords">int</span><span>&nbsp;j=</span><span
            class="plain">1</span><span>;&nbsp;j&nbsp;&lt;&nbsp;(n-i);&nbsp;j++)&#123;&nbsp;&nbsp;</span></span></li>
      <li class="alt">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="keywords">if</span><span>(arr[j-</span><span
            class="plain">1</span><span>]&nbsp;&gt;&nbsp;arr[j])&#123;&nbsp;&nbsp;</span></span></li>
      <li class="">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="comment">//swap&nbsp;elements</span><span>&nbsp;&nbsp;</span></span></li>
      <li class="alt">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;temp&nbsp;=&nbsp;arr[j-<span
            class="plain">1</span><span>];&nbsp;&nbsp;</span></span></li>
      <li class="">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;arr[j-<span
            class="plain">1</span><span>]&nbsp;=&nbsp;arr[j];&nbsp;&nbsp;</span></span></li>
      <li class="alt">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;arr[j]&nbsp;=&nbsp;temp;&nbsp;&nbsp;</span>
      </li>
      <li class="">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span>
      </li>
      <li class="alt">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
      </li>
      <li class="">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span>
      </li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
      <li class=""><span>&nbsp;&nbsp;</span></li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span class="keywords">public</span><span>&nbsp;</span><span
            class="keywords">static</span><span>&nbsp;</span><span
            class="keywords">void</span><span>&nbsp;main(String[]&nbsp;args)&nbsp;&#123;&nbsp;&nbsp;</span></span></li>
      <li class="alt">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="keywords">int</span><span>&nbsp;arr[]&nbsp;=&#123;</span><span class="plain">3</span><span>,</span><span
            class="plain">60</span><span>,</span><span class="plain">35</span><span>,</span><span
            class="plain">2</span><span>,</span><span class="plain">45</span><span>,</span><span
            class="plain">320</span><span>,</span><span class="plain">5</span><span>&#125;;&nbsp;&nbsp;</span></span>
      </li>
      <li class="">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
      </li>
      <li class="alt">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
            class="string">"Array&nbsp;Before&nbsp;Bubble&nbsp;Sort"</span><span>);&nbsp;&nbsp;</span></span></li>
      <li class="">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="keywords">for</span><span>(</span><span class="keywords">int</span><span>&nbsp;i=</span><span
            class="plain">0</span><span>;&nbsp;i&nbsp;&lt;&nbsp;arr.length;&nbsp;i++)&#123;&nbsp;&nbsp;</span></span></li>
      <li class="alt">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.print(arr[i]&nbsp;+&nbsp;<span
            class="string">"&nbsp;"</span><span>);&nbsp;&nbsp;</span></span></li>
      <li class="">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span>
      </li>
      <li class="alt">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println();&nbsp;&nbsp;</span>
      </li>
      <li class="">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
      </li>
      <li class="alt">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;bubbleSort(arr);<span
            class="comment">//sorting&nbsp;array&nbsp;elements&nbsp;using&nbsp;bubble&nbsp;sort</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class="">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
      </li>
      <li class="alt">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
            class="string">"Array&nbsp;After&nbsp;Bubble&nbsp;Sort"</span><span>);&nbsp;&nbsp;</span></span></li>
      <li class="">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="keywords">for</span><span>(</span><span class="keywords">int</span><span>&nbsp;i=</span><span
            class="plain">0</span><span>;&nbsp;i&nbsp;&lt;&nbsp;arr.length;&nbsp;i++)&#123;&nbsp;&nbsp;</span></span></li>
      <li class="alt">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.print(arr[i]&nbsp;+&nbsp;<span
            class="string">"&nbsp;"</span><span>);&nbsp;&nbsp;</span></span></li>
      <li class="">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span>
      </li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;</span></li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
      <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
    </ul>
  </div>
</div></div>
<p>Output:</p>
<div class="output">
  <pre>Array Before Bubble Sort <br/>
3 60 35 2 45 320 5  <br/>
Array After Bubble Sort <br/>
2 3 5 35 45 60 320  <br/>
</pre>

</div>

        </div>
    )
}

export default Jva_bs
